<template>
  <div class="HCMegagameDetail">
    <div class="HCMegagame-detail">
      <detail-navigation :activeNav="activeNav" :activeDetailBanner="activeDetailBanner" >
      </detail-navigation>

      <div class="page-nav">
        <page-nav :pageNav='pageNav' @toNode="toModule"></page-nav>
      </div>

      <apply-megagame :megagameApple="megagameApple" :activeNav="activeNav"></apply-megagame>

      <div class="nav-index" id="intro">
        <span class="nav-title">大赛简介</span>
        <active-intro :activeInfo="megagameIntro"></active-intro>
      </div>

      <div class="megagame-information">
        <div id="notification">
          <span class="nav-title">赛事通知</span>
          <notification-message :information="notification" :detailPath="'/informDetail'"></notification-message>
        </div>

        <div id="message">
          <span class="nav-title">相关资讯</span>
          <notification-message :information="message" :detailPath="'/informationDetail'"></notification-message>
        </div>
      </div>

      <div class="nav-index" id="condition">
        <span class="nav-title">参赛条件</span>
        <condition :condition="megagameCondition"></condition>
      </div>

      <div class="nav-index" id="plan">
        <span class="nav-title">赛事安排</span>
        <plan :activityPlan="activities"></plan>
      </div>

      <div class="nav-index" id="support">
        <span class="nav-title">赛事支持</span>
        <div class="megagame-support">
          <div class="item-case" v-for="(item,index) in megagameSupport" :key="index">
            <p>
              <img class="support-icon" :src="item.icon" alt="">
              <span class="support-title">{{item.title}}</span>
            </p>
            <!-- <p class="support-content">{{item.detail}}</p> -->
            <pre class="support-content">{{item.detail}}</pre>
          </div>
        </div>
      </div>

      <div class="nav-index" id="committee">
        <span class="nav-title">评委导师</span>
        <div class="megagame-committee">
          <div class="committees" v-for="(item,index) in megagameCommittee" :key="index">
            <img class="committee-portrait" :src="item.icon" alt="">
            <p class="committee-name">{{item.name}}</p>
            <p class="committee-job">{{item.occupation}}</p>
          </div>
        </div>
      </div>

      <div class="nav-index" id="organization">
        <span class="nav-title">组织机构</span>
        <detail-organization :organizationUnitsName="organizationUnitsName"
          :organizationUnits='organizationUnits'
          :associationInvestment='associationInvestment'>
        </detail-organization>
      </div>

    </div>
    <return-top></return-top>
  </div>
</template>

<script>
import DetailNavigation from '@/components/active/particulars/detailNavigation.vue' // 活动banner导航
import ReturnTop from '@/components/returnTop.vue'// 回到顶部
import PageNav from '@/components/active/particulars/pageNav.vue' // 页面导航
import ApplyMegagame from '@/components/active/particulars/applyMegagame.vue' // 报名大赛
import ActiveIntro from '@/components/active/particulars/activeIntro.vue' // 活动简介
import NotificationMessage from '@/components/active/particulars/notificationMessage.vue' // 通知资讯
import Condition from '@/components/active/particulars/condition.vue' // 参赛条件
import Plan from '@/components/active/particulars/plan.vue'
import DetailOrganization from '@/components/active/particulars/detailOrganization.vue'

export default {
  naem: 'HCMegagameDetail',
  props: {},
  components: {
    DetailNavigation,
    ReturnTop,
    PageNav,
    ApplyMegagame,
    ActiveIntro,
    NotificationMessage,
    Condition,
    Plan,
    DetailOrganization
  },
  data () {
    return {
      activeNav: {
        firstNav: '海创大赛',
        firstPath: '/HCMegagame',
        secondNav: '大赛详情',
        secondPath: '/HCMegagameDetail'
      }, // 详情页面包屑导航
      activeDetailBanner: '', // 详情页banner图
      pageNav: [
        { name: '大赛简介', id: 'intro' },
        { name: '参赛条件', id: 'condition' },
        { name: '赛事安排', id: 'plan' },
        { name: '赛事支持', id: 'support' },
        { name: '评委导师', id: 'committee' },
        { name: '组织机构', id: 'organization' },
        { name: '赛事通知', id: 'notification' },
        { name: '相关资讯', id: 'message' }
      ], // 页面锚点链接
      megagameApple: {}, // 大赛报名
      megagameIntro: '', // 大赛简介
      notification: [], // 通知
      message: [], // 资讯
      megagameCondition: '', // 参赛条件
      activities: [], // 赛事安排
      organizationUnitsName: ['指导单位', '主办单位', '协办单位', '承办单位', '支持单位', '执行机构', '投资机构'], // 组织机构名称
      organizationUnits: {}, // 组织机构单位
      associationInvestment: '', // 投资机构
      specificMegagameId: '', // 具体某项大赛id
      megagameSupport: [
        {
          name: '奖项设置',
          icon: require('@/assets/active/awards-icon.png'),
          content: '本届大赛设一等奖1名、二等奖3名、三等奖6名、优胜奖10名。获得决赛一二三等奖的项目团队，将分别给予奖金10万元、5万元、1万元，并颁发获奖证书和奖杯；获得决赛优胜奖的项目团队，给予奖金3000元，并颁发获奖证书。所有入围复赛项目团队均颁发参赛证书，并列入大赛重点服务对象，给予落地对接、市场拓展、融资合作、宣传推广等优先支持。'
        },
        {
          name: '投资服务',
          icon: require('@/assets/active/investServe-icon.png'),
          content: '中国技术创业协会留学人员创业园联盟联合投资机构，设立规模10亿元的大赛专项基金，给予参赛项目投资支持；协调100余家金融投资机构参与赛事活动，为参赛项目提供投融资服务；推动成立“留学人员科技成果转化投资引导基金”， 对初创小微留创企业进行重点投资。'
        },
        {
          name: '落地支持',
          icon: require('@/assets/active/support-icon.png'),
          content: '地方有关政府和单位对于参赛项目落地，根据当地产业政策和留学人员回国创业政策给予相应资助和优惠条件。通过开展项目对接考察活动等方式，协助参赛团队接洽全国300余家留学人员创业园区及有关单位，提供项目落地承接和创业孵化服务。'
        },
        {
          name: '资源对接',
          icon: require('@/assets/active/resource-icon.png'),
          content: '本届大赛设一等奖1名、二等奖3名、三等奖6名、优胜奖10名。获得决赛一二三等奖的项目团队，将分别给予奖金10万元、5万元、1万元，并颁发获奖证书和奖杯；获得决赛优胜奖的项目团队，给予奖金3000元，并颁发获奖证书。所有入围复赛项目团队均颁发参赛证书，并列入大赛重点服务对象，给予落地对接、市场拓展、融资合作、宣传推广等优先支持。'
        },
        {
          name: '创业辅导',
          icon: require('@/assets/active/coach-icon.png'),
          content: '利用中国海归创业导师库的资源优势，组建大赛导师团，举办项目培训会，免费为参赛团队提供商业策略、财务规划、销售管理、知识产权、园区政策等创业辅导。提供回国落户、学历认证、资助申报等咨询服务和协助。'
        },
        {
          name: '参赛补贴',
          icon: require('@/assets/active/subsidy-icon.png'),
          content: '报名及参与赛事活动不收取任何费用。大赛组委会为进入复赛和决赛的项目团队，在赛事举行期间提供免费食宿（每个项目提供1个标准间、2人每日三餐）和适当的交通补贴（每个项目限1位代表），具体办法另行通知。'
        }
      ], // 赛事支持
      megagameCommittee: []// 评委导师
    }
  },
  computed: {},
  created () {
    this.getDetailData()
    this.getMegagameData()
  },
  mounted () {
    document.documentElement.scrollTop = 0

    this.$parent.activeIndex = '4'
  },
  methods: {
    // 锚点链接
    toModule (id) {
      if (id === 'intro') {
        document.querySelector('#intro').scrollIntoView({ behavior: 'smooth', block: 'center' })
      }
      if (id === 'condition') {
        document.querySelector('#condition').scrollIntoView({ behavior: 'smooth', block: 'center' })
      }
      if (id === 'plan') {
        document.querySelector('#plan').scrollIntoView({ behavior: 'smooth', block: 'center' })
      }
      if (id === 'organization') {
        document.querySelector('#organization').scrollIntoView({ behavior: 'smooth', block: 'center' })
      }
      if (id === 'support') {
        document.querySelector('#support').scrollIntoView({ behavior: 'smooth', block: 'center' })
      }
      if (id === 'committee') {
        document.querySelector('#committee').scrollIntoView({ behavior: 'smooth', block: 'center' })
      }
      if (id === 'notification') {
        document.querySelector('#notification').scrollIntoView({ behavior: 'smooth', block: 'center' })
      }
      if (id === 'message') {
        document.querySelector('#message').scrollIntoView({ behavior: 'smooth', block: 'center' })
      }
    },

    // 获取大赛详情页数据
    getDetailData () {
      // const dataDetail = JSON.parse(sessionStorage.getItem('activityDetail'))
      // this.activeDetailBanner = dataDetail.banner // 大赛横幅
      // this.megagameApple = dataDetail // 活动报名
      // this.organizationUnits = JSON.parse(dataDetail.association) // 组织机构
      // this.associationInvestment = dataDetail.associationInvestment // 投资机构
      // this.specificMegagameId = dataDetail.id // 大赛id
      // this.megagameCondition = dataDetail.constrain // 参赛条件
      // this.megagameIntro = dataDetail.introduction // 大赛简介
      // console.log(dataDetail.introduction)
    },

    // 获取大赛相关数据
    async getMegagameData () {
      try {
        const res = await this.$get(this.$url.activity.HCMegagameSpecificData + this.$route.query.id)
        const { code, msg, data } = res.data
        if (code === 200 && data) {
          this.notification = data.innerInfos // 赛事通知
          this.message = data.outerInfos // 相关资讯
          this.activeDetailBanner = data.tbCompetition.banner // 大赛横幅
          this.megagameApple = data.tbCompetition // 活动报名
          this.megagameIntro = data.tbCompetition.introduction // 大赛简介
          this.megagameCondition = data.tbCompetition.constrain // 参赛条件
          this.activities = data.schedules // 赛事安排
          this.megagameSupport = data.supports // 赛事支持
          this.megagameCommittee = data.judges // 评委导师
          this.organizationUnits = JSON.parse(data.tbCompetition.association) // 组织机构
          this.associationInvestment = data.tbCompetition.associationInvestment // 投资机构
          sessionStorage.setItem('activityDetail', JSON.stringify(data.tbCompetition))
          console.log(data)
        } else {
          this.$message.error(msg)
        }
      } catch (err) {
        console.log(err)
      }
    }
  }
}
</script>

<style scoped lang="less">
.HCMegagameDetail {
  width: 100%;
  min-height: 100vh;
  background-color: #f5f5f5;
  margin-top: 7px;
  border: 1px solid #f5f5f5;
}
.HCMegagame-detail {
  position: relative;
  width: 1200px;
  min-height: 150vh;
  margin: 10px auto 100px;
  background-color: #f5f5f5;
  display: flex;
  flex-wrap: wrap;
  .page-nav{
    position: -webkit-sticky;
    position: sticky;
    top: 0;
    z-index: 10;
  }
}
.nav-index{
  width: 985px;
  padding-left: 20px;
  box-sizing: border-box;
  padding: 20px 0 25px 0;
  background-color: #fff;
  // overflow: hidden;
}
.nav-title{
    display: inline-block;
    box-sizing: border-box;
    padding-left: 20px;
    font-size: 20px;
    font-weight: 600;
    color: #000;
    border-left: 4px solid #3056D9;
    border-radius: 2px 0 0 2px;
}

.megagame-support{
  box-sizing: border-box;
  padding: 0 30px;
  margin-top: 30px;
  .item-case{
    margin-bottom: 30px;
    .support-icon{
      width: 44px;
      height: 44px;
      vertical-align: middle;
      margin-right: 10px;
    }
    .support-title{
      display: inline-block;
      font-size: 16px;
      font-weight: bold;
    }
    .support-content{
      line-height: 20px;
      font-size: 16px;
      color: #000;
      font-family: "Microsoft YaHei" !important;
      margin:10px 0 0 55px;
      white-space: pre-wrap;
      word-wrap: break-word;
      line-height: 1.5;
    }
  }
}

.megagame-committee{
  box-sizing: border-box;
  padding: 20px 30px;
  display: flex;
  flex-wrap: wrap;
    .committees{
      margin-right: 16px;
      .committee-portrait{
        width: 172px;
        height: 229px;
      }
      .committee-name{
        width: 172px;
        font-size: 18px;
        font-weight: 600;
        margin-top: 8px;
        // margin: 8px 0 8px;
      }
      .committee-job{
        width: 172px;
        font-size: 14px;
        color: #898B91;
        margin-bottom: 24px;
      }
    }
    .committees:nth-of-type(5n){
      margin-right: 0;
    }

}

.megagame-information{
  width: 207px;
  background-color: #fff;
  position: absolute;
  top: 550px;
  right: 0;
  // margin: -232px 0 0 8px;
  box-sizing: border-box;
  padding: 15px 0;
  overflow: hidden;
}
</style>
